export interface CookieConsent {
  necessary: boolean;
  analytics: boolean;
  marketing: boolean;
  timestamp: number;
  version: number;
}

export const CONSENT_KEY = "totoro_cookie_consent";
export const CONSENT_VERSION = 1;

const noop = () => {};

let reopenCookiePreferences: () => void = noop;

export const openCookiePreferences = () => {
  reopenCookiePreferences();
};

export const registerCookiePreferenceOpener = (opener: () => void) => {
  reopenCookiePreferences = opener;

  return () => {
    if (reopenCookiePreferences === opener) {
      reopenCookiePreferences = noop;
    }
  };
};

export const readStoredCookieConsent = (): CookieConsent | null => {
  try {
    const consent = localStorage.getItem(CONSENT_KEY);

    if (!consent) {
      return null;
    }

    return JSON.parse(consent) as CookieConsent;
  } catch (error) {
    console.error("Failed to read cookie consent:", error);
    return null;
  }
};
